import React, { CSSProperties } from 'react';
import darkPurdueLogo from '../PU-V-Full-Rev-RGB.png';
import lightPurdueLogo from '../PU-V-Full-RGB.png';
import jtrpLogo from '../JTRP_Logo_700px.png';

interface LogosProps {
  style?: CSSProperties
}

const Logos = (props: LogosProps) => {
  return (
    <div style={props.style}>
      {/*<div style={{display: 'flex', flexDirection: 'row'}}>*/}
      <img
        src={jtrpLogo}
        alt=""
        style={{ width: 'calc(33% - 5px)', objectFit: 'contain', flexGrow: 1, margin: '0 5px' }}/>
      {/*style={{width: '33%'}}/>*/}
      {localStorage.getItem('darkMode') === 'true' ?
        <img src={darkPurdueLogo}
             alt=""
             style={{
               width: 'calc(33% - 5px)',
               objectFit: 'contain',
               alignSelf: 'center',
               flexGrow: 1,
               margin: '0 5px',
             }}/>
        :
        <img src={lightPurdueLogo}
             alt=""
             style={{
               width: 'calc(33% - 5px)',
               objectFit: 'contain',
               alignSelf: 'center',
               flexGrow: 1,
               margin: '0 5px',
             }}/>
        // style={{minWidth: '100px', objectFit: "contain", flexGrow: 1, margin: '10px'}}/>
      }
      {/*<img*/}
      {/*    src={indotLogo}*/}
      {/*    alt=""*/}
      {/*    style={{width: 'calc(33% - 5px)', objectFit: "contain", flexGrow: 1, margin: '0 5px'}}/>*/}
      {/*style={{width: '105px', height: '105px'}}/>*/}
      {/*</div>*/}
    </div>
  );
};

export default Logos;
